import { IFlowPlayerOptions } from '../models/core/flowplayer-options';
import { Log } from 'ng2-logger';
import { Common } from './common';
import React from 'react';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import { ISignleActivityCard } from '../models/components/single-activity-card';

const T = Translator.create();
const _logger = Log.create('FlowPlayerTs');

export default class FlowPlayerTs extends React.Component<ISignleActivityCard> {
    public FlowOptions: IFlowPlayerOptions;
    private _common: Common;
    private _vimeoCount: number = 0;
    private enrollmentId: string = '';
    private saveTrackingUrl: string = '';

    constructor(props: ISignleActivityCard, options: IFlowPlayerOptions) {
        super(props);

        this._common = new Common();
        if (!options.lastcuepint) {
            options.lastcuepint = -1;
        }
        if (!options.nextcuepint) {
            options.nextcuepint = 0;
        }
        if (!options.currentpos) {
            options.currentpos = 0;
        }
        if (!options.tracktime) {
            options.tracktime = 10;
        }
        if (!options.lastsubmsec) {
            options.lastsubmsec = -1;
        }
        if (!options.lastsviewsec) {
            options.lastsviewsec = -1;
        }
        if (!options.disableSeek) {
            options.disableSeek = 0;
        }
        if (!options.seekTime) {
            options.seekTime = null;
        }
        if (!options.ratio) {
            options.ratio = 3 / 4;
        }
        if (!options.cuepoints) {
            options.cuepoints = [];
        }
        if (!options.data) {
            options.data = {};
        }




        this.FlowOptions = options;
        this.BuildVideo();
    }

    public BuildYoutubeVideo = () => {
        this.FlowOptions.videotype = 'youtube';
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode!.insertBefore(tag, firstScriptTag);
        this.BuildYoutubeEvents();
    }

    public BuildVimeoVideo = (vobj: any) => {
        const getVimeoVideSetTimeout = () => {
            if (this._vimeoCount <= 6) {
                if (document.getElementById(this.FlowOptions.player!)) {

                    this.FlowOptions.videotype = 'vimeo';
                    $('#' + this.FlowOptions.player).replaceWith('<iframe id="' + this.FlowOptions.player + '" src="//player.vimeo.com/video/' + vobj.id + '?api=1&player_id=' + this.FlowOptions.player + '&fullscreen=0&autoplay=' + this.FlowOptions.autoPlay + '" width="100%" height="400" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
                    this.BuildVimeoEvents();
                } else {
                    this._vimeoCount = this._vimeoCount + 1
                    setTimeout(getVimeoVideSetTimeout, 1000);
                }
            }
        }

        if (document.getElementById(this.FlowOptions.player!)) {
            getVimeoVideSetTimeout();
        } else {
            this._vimeoCount = this._vimeoCount + 1
            setTimeout(getVimeoVideSetTimeout, 1000);
        }
    }

    public BuildDailymotionVideo = () => {
        this.FlowOptions.videotype = 'dailymotion';
        const fileName = this.FlowOptions.videoParameters!.Meta!.VideoURL.substring(this.FlowOptions.videoParameters!.Meta!.VideoURL.lastIndexOf('/') + 1);
        const src = fileName.split('_')[0];
        $('#' + this.FlowOptions.player).replaceWith('<iframe id="' + this.FlowOptions.player + '" src="http://www.dailymotion.com/embed/video/' + src + '?autoplay=' + this.FlowOptions.autoPlay + '" frameborder="0" width="100%" height="400" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');

        this.BuildVimeoEvents();
    }

    public BuildVideo = () => {
        const vid = [];
        let engine = 'html5';
        // prepare cuepoints
        const playerId = this.FlowOptions.player;

        let questionsSeq = 0;
        this.FlowOptions.videoParameters!.Interactions!.forEach(question => {
            let que = this.FlowOptions.cuepoints?.find(cue => cue.Id === question.ID);
            if (!que) {
                this.FlowOptions.cuepoints!.push({
                    time: question.ShowOnSecond,
                    Id: question.ID,
                    num: questionsSeq
                });
                questionsSeq++;
            }

        });

        const vobj: any = this.GetById(this.FlowOptions.videoParameters!.Meta!.VideoURL, this.FlowOptions.videoParameters!.Extension!);

        if (vobj.ext === 'youtube') {
            this.BuildYoutubeVideo();
        } else if (vobj.ext === 'vimeo') {
            this.BuildVimeoVideo(vobj);

        } else if (vobj.ext === 'dailymotion') {
            this.BuildDailymotionVideo();
        } else {
            this.FlowOptions.videotype = 'flow';
            
            const type = vobj.ext
            vid.push({ [type]: vobj.id });
        
            const api = ($('#' + this.FlowOptions.player) as any).flowplayer({
                cuepoints: this.FlowOptions.cuepoints,
                engine,
                playlist: [vid],
                ratio: this.FlowOptions.ratio,

            });
            this.FlowOptions.api = api[0];
            this.BuildPlayerEvents();
            if (playerId) {
                this.BuildSpeedControl(playerId);
            }
        }
    }

    private GetById = (code: string, filetype: string) => {
        let reg;
        const obj: any = {};
        let matches: any = {};

        if (code.indexOf('vimeo') !== -1) {
            reg = new RegExp(/(\d+)/);
            obj.ext = 'vimeo';
        } else if (code.indexOf('youtu') !== -1) {
            reg = /(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=)|youtube-nocookie\.com(?:\/embed\/|\/v\/|\/watch\?v=))([\w-]{10,12})/g;
            obj.ext = 'youtube';
        } else if (code.indexOf('dailymotion') !== -1) {
            reg = new RegExp(/(\d+)/);
            obj.ext = 'dailymotion';
        } else {
            obj.ext = filetype;
            obj.id = code;
            return obj;
        }

        matches = reg.exec(code);
        if (matches) {
            obj.id = matches[1];
        } else {
            obj.ext = 'none';
            obj.id = -1;
        }
        return obj;
    }

    private VideoSeek = (to: any) => {
        switch (this.FlowOptions.videotype) {
            case 'youtube':
                this.FlowOptions.apiFlow.seekTo(to);
                this.FlowOptions.apiFlow.playVideo();
                break;
            case 'vimeo':
                this.FlowOptions.api.api('seekTo', to);
                this.FlowOptions.api.api('play');
                break;
            default:
                this.FlowOptions.apiFlow.disable(false);
                this.FlowOptions.apiFlow.seek(to, () => {
                    this.FlowOptions.apiFlow.resume();
                });
                break;
        }
    }

    private BuildVimeoEvents = () => {

        this.FlowOptions.api = window.$f($('#' + this.FlowOptions.player)[0]);

        this.FlowOptions.api.addEvent('ready', () => {
            this.FlowOptions.api.videoposition = 0;
            this.FlowOptions.api.api('getDuration', (value: any) => {
                this.VideoDuration(value)
            });
            this.FlowOptions.api.addEvent('play', this.VimeoStatePlay);
            this.FlowOptions.api.addEvent('seek', this.VimeoStateSeek);
            this.FlowOptions.api.addEvent('finish', this.VimeoStateFinish);
            this.FlowOptions.api.addEvent('playProgress', this.VimeoStateProgress);
        });

    }

    public VideoDuration = (duration: any) => {
        this.enrollmentAddAction();
        if (duration && duration > 0) {
            this.VideoFillTrack(duration);

            let bToken: string | null = '';
            if (this._common.GetAuthLocalStorage()) {
                bToken = this._common.GetAuthLocalStorage().access_token;
            }

            const _body = JSON.stringify({
                classId: this.props.classId!,
                activityId: this.props.activityCard!.activityId,
                duration: duration
            });

            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    Authorization: 'Bearer ' + bToken,
                },
                body: _body
            };

            this.fetchVideoDuration(requestOptions);

        }
    }

    private fetchingEnrollment = async (requestModel: any) => {
        let isError = false;
        let errorList: any;
        try {
            let enrollmentData = await fetch(window.appSettings.API_URL + '/api/enrollment/addaction', requestModel)
                .then((responseData: Response) => {
                    return responseData;
                }).then((responseData: Response) => {
                    if (responseData.status !== 200) {
                        isError = true;
                    }
                    return responseData.json();
                }).then((response) => {
                    if (isError) {
                        errorList = response;
                    } else {
                        if (!this.enrollmentId) {
                            this.enrollmentId = response[0].enrollmentId;
                        }
                        return response;
                    }
                });

            if (isError) {
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                });
            }
            else if (enrollmentData) {

                this.FlowOptions.updateDataFunction(enrollmentData);
            }
        } catch (error: any) {
            Notification.setNotification('error', T.t('r_default_error_message'), 'topRight');
        }
    }

    private enrollmentAddAction = () => {
        let bToken: string | null = '';
        if (this._common.GetAuthLocalStorage()) {
            bToken = this._common.GetAuthLocalStorage().access_token;
        }

        let activityId = this.props.activityCard!.activityId;

        let splitted = this.props.activityCard!.activityId!.split("_") ?? null;

        if (splitted) {
            activityId = splitted[0];
        }

        const _body = JSON.stringify({
            classId: this.props.classId!,
            activityId: activityId,
            ActivityCompletionType: this.props.activityCard!.completionType,
            EnrollmentId: this.props.activityCard!.videoInformation ? (this.props.activityCard!.videoInformation.enrollmentId ?? (this.props.activityCard!.enrollmentId ?? '')) : (this.props.activityCard!.enrollmentId ?? '')
        });

        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                Authorization: 'Bearer ' + bToken,
            },
            body: _body
        };

        this.fetchingEnrollment(requestOptions);

    }

    private BindCuepoint = (cuepoint: any) => {
        if (cuepoint.num > this.FlowOptions.lastcuepint!) {
            this.FlowOptions.lastcuepint = cuepoint.num;

            const currentTime = Math.round(this.GetCurrentTime());
            const filterArray = this.FlowOptions.videoParameters!.Interactions!.filter((x: any) => x.ShowOnSecond === currentTime);
            const max = filterArray.length;
            let duration;

            if (this.FlowOptions.videotype === 'flow') {
                duration = this.FlowOptions.apiFlow.video.duration;
            } else if (this.FlowOptions.videotype === 'youtube') {
                duration = this.FlowOptions.apiFlow.playerInfo.duration;
            } else {
                duration = this.FlowOptions.Tracking.ViewLog.length - 1;
            }

            if (max > 0 && (this.FlowOptions.seekTime! < currentTime || this.FlowOptions.seekTime === Math.round(duration))) {
                this.VideoPause();
                this.BuildQuestion(cuepoint);
            }

        }
    }

    private VimeoStatePlay = (data: any) => {
        let time = Math.round(data.seconds);
        if (time === 0) {
            this.enrollmentAddAction()
        }
    }

    private VideoProgress = (progress: any) => {
        if (this.FlowOptions.editmode!) {
            return false;
        }
        if (!this.FlowOptions.Tracking.AttemptDate) {
            const dte = new Date();
            this.FlowOptions.Tracking.AttemptDate = dte.toJSON();
        }

        if (!this.FlowOptions.lastsviewsec || progress !== this.FlowOptions.lastsviewsec) {
            if (this.FlowOptions.Tracking.ViewLog === undefined) {
                this.FlowOptions.Tracking.ViewLog = [];
            }
            if (!this.FlowOptions.Tracking.ViewLog[progress]) {
                this.FlowOptions.Tracking.ViewLog[progress] = 1;
            } else {
                this.FlowOptions.Tracking.ViewLog[progress]++;
            }

            this.FlowOptions.lastsviewsec = progress;
        }

        if (this.FlowOptions.tracktime && progress % this.FlowOptions.tracktime === 0 && this.FlowOptions.lastsubmsec !== progress) {

            this.FlowOptions.lastsubmsec = progress;
            this.SubmitTrack();
        }

    }

    private VimeoStateProgress = (data: any) => {
        let time = 0;
        this.FlowOptions.videoposition = data.seconds;
        time = Math.round(data.seconds);

        if (this.FlowOptions.cuepoints) {
            this.FlowOptions.cuepoints.forEach(item => {
                if (item.time === time || (item.time < time && this.FlowOptions.lastcuepint! < item.num)) {
                    this.BindCuepoint(item);
                }
            });
        }
        this.VideoProgress(time);
    }

    private VimeoStateFinish = () => {
        this.SubmitTrack();
    }
    private VimeoStateSeek = (data: any) => {
        this.FlowOptions.videoposition = data.seconds;
        this.CheckSeekBack();
    }

    private BuildYoutubeEvents = () => {
        if (this.FlowOptions.videoParameters) {
            if (this.FlowOptions.videoParameters.Meta) {
                if (this.FlowOptions.videoParameters.Meta.VideoURL) {
                    const id = this.GetById(this.FlowOptions.videoParameters.Meta.VideoURL, this.FlowOptions.videoParameters.Extension!).id;
                    this.FlowOptions.api = $('#' + this.FlowOptions.player)[0];

                    setTimeout(() => {
                        this.FlowOptions.apiFlow = new window.YT.Player(this.FlowOptions.player, {
                            height: '400',
                            width: '100%',
                            videoId: id,
                            events: {
                                'onStateChange': this.YoutubeStateChange
                            },
                            playerVars: {
                                wmode: 'opaque',
                                'autoplay': this.FlowOptions.autoPlay,
                            }
                        });
                    }, 4000);
                }

            }

        }
    }

    private fetchVideoDuration = (requestModel: any) => {

        let isError = false;
        let errorList: any;
        try {
            fetch(window.appSettings.API_URL + '/api/video/setvideoduration', requestModel)
                .then((responseData: Response) => {
                    return responseData;
                }).then((responseData: Response) => {
                    if (responseData.status !== 200) {
                        isError = true;
                    }
                    return responseData.json();
                }).then((response) => {
                    if (isError) {
                        errorList = response;
                    } else {
                        return response;
                    }
                });

            if (isError) {
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                });
            }
        } catch (error: any) {
            Notification.setNotification('error', T.t('r_set_video_duration_error_message'), 'topRight');
        }
    }

    private SetPlaybackSpeed = (speed: number, playerId: string) => {
        const player = this.FlowOptions;
        switch (player.videotype) {
            case 'youtube':
                player.apiFlow.setPlaybackRate(speed);
                break;
            case 'vimeo':
                player.api.api('setPlaybackRate', speed);
                break;
            default:
                player.apiFlow.speed(speed);
                break;
        }
    }

    private BuildSpeedControl = (playerId: string) => {
        if ($('#' + playerId + ' .fp-speed-control').length === 0) {
            const speedControlHtml = `
                <div class="fp-speed-control">
                    <button id="speed-button-${playerId}" class="fp-speed-button">1x</button>
                    <div id="speed-slider-container-${playerId}" class="fp-speed-slider-container" style="display: none;">
                        <span class="fp-speed-value">0.5x</span>
                        <input type="range" id="speed-slider-${playerId}" min="0.5" max="2" step="0.25" value="1" class="fp-speed-slider">
                        <span class="fp-speed-value">2x</span>
                    </div>
                </div>
            `;
            $('#' + playerId + ' .fp-controls').append(speedControlHtml);

            $('#speed-button-' + playerId).on('click', () => {
                $('#speed-slider-container-' + playerId).toggle();
            });

            $('#speed-slider-' + playerId).on('input', (event) => {
                const speed = parseFloat((event.target as HTMLInputElement).value);
                this.SetPlaybackSpeed(speed, playerId);
                $('#speed-value-' + playerId).text(speed + 'x');
                $('#speed-button-' + playerId).text(speed + 'x');
            });
        }
    }

    private YoutubeStateChange = (newState: any) => {
        switch (newState.data) {
            case -1:
                this.enrollmentAddAction();
                if (this.FlowOptions.apiFlow.playerInfo && this.FlowOptions.apiFlow.playerInfo.duration > 0) {
                    this.VideoFillTrack(this.FlowOptions.apiFlow.playerInfo.duration);

                    let bToken: string | null = '';
                    if (this._common.GetAuthLocalStorage()) {
                        bToken = this._common.GetAuthLocalStorage().access_token;
                    }

                    const _body = JSON.stringify({
                        classId: this.props.classId!,
                        activityId: this.props.activityCard!.activityId,
                        duration: this.FlowOptions.apiFlow.playerInfo.duration
                    });

                    const requestOptions = {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*',
                            Authorization: 'Bearer ' + bToken,
                        },
                        body: _body
                    };

                    this.fetchVideoDuration(requestOptions);

                }
                break;
            case 0:
                this.SubmitTrack();
                break;
            case 1:
                if (this.FlowOptions.Tracking.ViewLog === undefined && this.FlowOptions.apiFlow.playerInfo.duration > 0) {
                    this.VideoFillTrack(this.FlowOptions.apiFlow.playerInfo.duration);
                }
                clearInterval(this.FlowOptions.api.si);
                this.YoutubeCuePoint();
                this.FlowOptions.api.si = setInterval(() => {
                    this.YoutubeCuePoint();
                }, 1000);
                this.SubmitTrack();
                break;
            case 2:
                clearInterval(this.FlowOptions.api.si);
                this.CheckSeekBack();
                break;
            case 3:
                break;
            case 5:
                break;
        }
    }

    private TrackingWhenFirstAttempt = () => {
        const temp = this._common.ClearConvertVideTestLogViewData(this.FlowOptions.Tracking.viewData!).split(',');
        if (temp != null || temp !== '') {
            for (const fori of temp) {
                const datas = fori.split('-');
                const fdb = parseInt(datas[0]);
                const ldb = parseInt(datas[1]);     // 10luk sayı birimi daha dogru calisiyor

                for (let j = fdb; j <= ldb; j++) {
                    this.FlowOptions.Tracking.ViewLog[j] = 1;
                }
            }
        }

    }

    private TrackingData = () => {
        let data = {};

        if (this.FlowOptions.videotype === 'flow') {
            data = {
                viewParts: JSON.stringify(this.FlowOptions.Tracking.ViewParts),
                totalPartSec: this.FlowOptions.Tracking.TotalPartSec,
                duration: parseInt(this.FlowOptions.apiFlow.video.duration),   // opt.Tracking.ViewLog.length,// parseInt(opt.api.video.duration), //opt.data.Meta.Duration,         //opt.Tracking.ViewLog.length,
                attemptDate: this.FlowOptions.Tracking.AttemptDate,
                response: this.FlowOptions.Tracking.InteractionResponses
            };
        } else {
            let _duration;

            if (this.FlowOptions.videotype === 'youtube') {
                _duration = this.FlowOptions.apiFlow.playerInfo.duration;
            } else {
                _duration = this.FlowOptions.Tracking.ViewLog.length;
            }

            data = {
                viewParts: JSON.stringify(this.FlowOptions.Tracking.ViewParts),
                totalPartSec: this.FlowOptions.Tracking.TotalPartSec,
                duration: _duration,   // opt.Tracking.ViewLog.length,// parseInt(opt.api.video.duration), //opt.data.Meta.Duration,         //opt.Tracking.ViewLog.length,
                attemptDate: this.FlowOptions.Tracking.AttemptDate,
                response: this.FlowOptions.Tracking.InteractionResponses
            };
        }
        return data;
    }

    private UpdateTrackingViewLog = () => {
        let partStart = -1;
        let partEnd = -1;
        const viewLog = this.FlowOptions.Tracking.ViewLog;
        const viewParts = this.FlowOptions.Tracking.ViewParts;
        const cuepoints = this.FlowOptions.cuepoints;

        for (let i = 0; i <= viewLog.length; i++) {
            if (viewLog[i] !== undefined && viewLog[i] > 0 && i < viewLog.length) {
                if (partStart === -1) {
                    partStart = i;
                }
                partEnd = i;
            } else if (partStart >= 0 && partEnd > 0) {

                const lastPartEnd = viewParts.length > 0
                    ? parseInt(viewParts[viewParts.length - 1].split('-')[1])
                    : -1;

                if (cuepoints?.length == 0 || lastPartEnd === partStart - 1 || viewParts.length === 0) {
                    viewParts.push(`${partStart}-${partEnd}`);
                    const distance = partEnd - partStart;
                    if (distance > 0) {
                        this.FlowOptions.Tracking.TotalPartSec += distance;
                    }
                    partStart = -1;
                    partEnd = -1;
                } else {
                    this.seekTo(lastPartEnd);
                    break;
                }
            }
        }
    }

    private seekTo = (position: number) => {
        const { apiFlow, videotype } = this.FlowOptions;
        switch (videotype) {
            case 'youtube':
                apiFlow.seekTo(position);
                break;
            case 'vimeo':
                apiFlow.api('seekTo', position);
                break;
            default:
                apiFlow.seek(position);
                break;
        }
    };

    private ajaxCallSaveTracking = (data: any) => {
        this.FlowOptions.ajaxcall = $.ajax({
            type: 'POST',
            url: this.saveTrackingUrl,
            beforeSend: (xhr) => {
                xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
            },
            data,
            success: (returnData) => {
                if (returnData === '{Ok:EnforceWatchingSingleVideo}') {
                    window.location.href = '/Video/AlertEnforceWatchingSingleVideo?courseId=' + this.FlowOptions.courseId;
                }
            },
            error: (errorData) => {
            }
        });
    }

    private SubmitTrack = (counter?: number) => {
        if (this.FlowOptions.editmode) {
            return false;
        }
        const dte = new Date();
        this.FlowOptions.Tracking.EndAttemptDate = dte.toJSON();
        this.FlowOptions.Tracking.ViewParts = [];
        this.FlowOptions.Tracking.TotalPartSec = 0;

        if (this.FlowOptions.isFirst === 1) {

            this.TrackingWhenFirstAttempt();

        }

        this.UpdateTrackingViewLog();

        if (this.FlowOptions.videotype === 'flow' && this.FlowOptions.isFirst === 1) {
            this.FlowOptions.Tracking.ViewParts = this.FlowOptions.Tracking.viewData;
            this.FlowOptions.apiFlow.seek(this.FlowOptions.seekTime);
            this.FlowOptions.isFirst = 0;
        }

        const data = this.TrackingData();

        let currentUrl = this.FlowOptions.report;
        const queryParams = new URLSearchParams(window.location.search);
        const urlEnrollmentId = queryParams.get('enrollmentId');

        if (currentUrl) {
            if (!urlEnrollmentId) {
                currentUrl = currentUrl.replace(/(\?|&)enrollmentId=([^&]*)/, `$1enrollmentId=${this.enrollmentId}`);
            }
            this.saveTrackingUrl = currentUrl;

        }

        if (counter) {
            if (counter === 1) {
                this.ajaxCallSaveTracking(data)
            }
        }
        else {
            this.ajaxCallSaveTracking(data)

        }


    }

    private BuildPlayerEvents = () => {
        let counter = 0;

        if ($('#' + this.FlowOptions.player) && $('#' + this.FlowOptions.player).data('flowplayer')) {
            $('#' + this.FlowOptions.player).data('flowplayer').bind('ready', (e: any, api: any, vobj: any) => {
                const duration = Math.round(vobj.duration);
                this.VideoFillTrack(duration);
                this.FlowOptions.apiFlow = api;
            });

            $('#' + this.FlowOptions.player).data('flowplayer').bind('resume', (e: any, api: any) => {
                if (Math.round(api.video.time) === 0 && counter === 0) {
                    this.enrollmentAddAction()
                    counter += 1;

                }
            });

            // fire cuepoint. show question		
            $('#' + this.FlowOptions.player).data('flowplayer').bind('cuepoint', (e: any, api: any, cuepoint: any) => {
                this.BindCuepoint(cuepoint);
            });

            // firing about each 0/250 sec. filling ViewLog each second. sending Tracking to backend
            $('#' + this.FlowOptions.player).data('flowplayer').bind('progress', (e: any, api: any) => {
                this.VideoProgress(Math.round(api.video.time));
            });

            // sending Tracking to backend on finish
            $('#' + this.FlowOptions.player).data('flowplayer').bind('finish', (e: any, api: any) => {
                this.SubmitTrack();
            });

            // check where we are before seek
            $('#' + this.FlowOptions.player).data('flowplayer').bind('beforeseek', (e: any, api: any, target: any) => {
                this.FlowOptions.currentpos = this.FlowOptions.apiFlow.video.time;
                if (this.FlowOptions.disableSeek && this.FlowOptions.isStudent && this.FlowOptions.isFirst === 0) {
                    if (target > this.FlowOptions.currentpos!) {
                        e.preventDefault();
                    }
                }
            });
            // check after and return to last not passed question

            $('#' + this.FlowOptions.player).data('flowplayer').bind('seek', (e: any, api: any) => {
                this.CheckSeekBack();

            });
            // rebuilding ui on fullscreen		

            $('#' + this.FlowOptions.player).data('flowplayer').bind('fullscreen', (e: any, api: any) => {
                $('#' + this.FlowOptions.question).addClass('full');
            });
            // rebuilding ui on normal state
            $('#' + this.FlowOptions.player).data('flowplayer').bind('fullscreen-exit', (e: any, api: any) => {
                $('#' + this.FlowOptions.question).removeClass('full');
            });
        }
    }

    private VideoFillTrack = (duration: number) => {
        if (!this.FlowOptions.Tracking.ViewLog) {
            this.FlowOptions.Tracking.ViewLog = [];
            for (let i = 0; i < duration; i++) {
                this.FlowOptions.Tracking.ViewLog.push(0);
            }
        }
        this.FlowOptions.Tracking.ViewParts = [];
        this.FlowOptions.Tracking.TotalPartSec = 0;
    }

    private BuildEvents = () => {
        //  cheking answer on form  submit
        let counter = 1;

        $('form', '#' + this.FlowOptions.question).on('submit', (eventForm: any) => {

            const ths = $(eventForm.target);
            const track: any = {};
            let dte;
            //     check, track = {}, dte;
            const check: any = this.CheckAnswer(ths);

            $('.answer p', '#' + this.FlowOptions.question).text(check.answer);
            if (check.correct) {
                $('.answer h4', '#' + this.FlowOptions.question).text(this.FlowOptions.correct!);
                $('.answer .btn_repeat_video', '#' + this.FlowOptions.question).hide();
                $('.answer .btn_go_to_back', '#' + this.FlowOptions.question).hide();
                $('.answer .btn_rep', '#' + this.FlowOptions.question).hide();
                $('.answer .btn_go', '#' + this.FlowOptions.question).show();
                this.FlowOptions.nextcuepint = this.FlowOptions.lastcuepint! + 1;
            } else {
                $('.answer h4', '#' + this.FlowOptions.question).text(this.FlowOptions.wrong!);

                if (check.obj.ContinueEvenWrong) {
                    $('.answer .btn_go_to_back', '#' + this.FlowOptions.question).hide();
                    $('.answer .btn_rep', '#' + this.FlowOptions.question).hide();
                    $('.answer .btn_go', '#' + this.FlowOptions.question).show();
                    this.FlowOptions.nextcuepint = this.FlowOptions.lastcuepint! + 1;
                } else {
                    $('.answer .btn_rep', '#' + this.FlowOptions.question).show();
                    $('.answer .btn_go', '#' + this.FlowOptions.question).attr({
                        rel: ''
                    }).hide();
                }

                if (check.obj.GoBackTo >= 0 && !check.obj.ContinueEvenWrong) {

                    $('.answer .btn_repeat_video', '#' + this.FlowOptions.question).hide();
                    $('.answer .btn_go_to_back', '#' + this.FlowOptions.question).attr({
                        rel: check.obj.GoBackTo
                    }).show(); // If you want to user can make a choice, use .show() instead of .trigger("click")
                } else {
                    $('.answer .btn_go_to_back', '#' + this.FlowOptions.question).hide();
                    $('.answer .btn_repeat_video', '#' + this.FlowOptions.question).attr({
                        rel: ''
                    }).hide();
                }
            }

            this.ShowAnswer();
            // filling Tracking
            track.Correct = check.correct;
            track.ID = check.obj.ID;
            dte = new Date();
            track.Responses = [];
            track.Responses.push({
                Date: dte.toJSON(),
                Response: check.response
            });
            if (!this.FlowOptions.Tracking.InteractionResponses) {
                this.FlowOptions.Tracking.InteractionResponses = [];
            }
            // log (track)
            let response = this.FlowOptions.Tracking.InteractionResponses.find((res: any) => res.ID === track.ID)
            if (!response) {
                this.FlowOptions.Tracking.InteractionResponses.push(track);

            }

            this.SubmitTrack(counter);
            this.FlowOptions.Tracking.InteractionResponses = [];
            counter = counter + 1;

            return false;
        });

        $('.btn_skip', '#' + this.FlowOptions.question).on('click', () => {
            if (!this.FlowOptions.editmode) {
                return false;
            }
            $('.btn_go', '#' + this.FlowOptions.question).trigger('click');
            return false;
        });


        // go ahead
        $('.btn_go', '#' + this.FlowOptions.question).on('click', () => {

            $('.q_hold', '#' + this.FlowOptions.question).fadeOut('fast', () => {
                $('#' + this.FlowOptions.question).hide();
                this.VideoPlay();
            });
            return false;
        });
        // repeat question
        $('.btn_rep', '#' + this.FlowOptions.question).on('click', () => {
            this.ShowQuestion();
            return false;
        });

        // repeat video		
        $('.btn_repeat_video', '#' + this.FlowOptions.question).on('click', (event: any) => {

            const rel = Number($(event.target).attr('rel'));
            this.FlowOptions.lastcuepint = (this.FlowOptions.lastcuepint === 0) ? -1 : this.FlowOptions.lastcuepint! - 1;

            $('.q_hold', '#' + this.FlowOptions.question).fadeOut('fast', () => {
                $('#' + this.FlowOptions.question).fadeOut('fast', () => {
                    this.VideoSeek(Math.max(0, rel));
                });
            });
            return false;
        });

        $('.btn_go_to_back', '#' + this.FlowOptions.question).on('click', (event: any) => {

            const rel = Number($(event.target).attr('rel'));
            this.FlowOptions.lastcuepint = (this.FlowOptions.lastcuepint === 0) ? -1 : this.FlowOptions.lastcuepint! - 1;

            $('.q_hold', '#' + this.FlowOptions.question).fadeOut('fast', () => {
                $('#' + this.FlowOptions.question).fadeOut('fast', () => {
                    this.VideoSeek(Math.max(0, rel));
                });
            });
            return false;
        });
    }

    private CheckAnswer = (form: any) => {

        //   qobj, val, allansw, ind, check, response = [];
        const response: any[] = [];
        const qobj = this.GetQById(form.attr('rel'));

        if (qobj == null) {
            alert(this.FlowOptions.cantfind);
            return false;
        }
        if (qobj.QuestionType === 'Single') {
            const val = $('input[name=q]:checked', form).val();

            if (val === qobj.Answer[0]) {
                return {
                    obj: qobj,
                    answer: qobj.Choices[val!.toString()].Feedback,
                    response: qobj.Choices[val!.toString()].ChoiceText,
                    correct: true
                };
            } else if (val) {
                return {
                    obj: qobj,
                    answer: qobj.Choices[val.toString()].Feedback,
                    response: qobj.Choices[val.toString()].ChoiceText,
                    correct: false
                };
            }
        } else {
            const allansw = this.Clone(qobj.Answer);
            const check = $('input:checkbox[name=q]:checked');
            check.each(function () {
                const val = $(this).val();
                response.push(qobj.Choices[val!.toString()].ChoiceText);
                const ind = $.inArray(val, allansw);
                if (ind >= 0) {
                    allansw.splice(ind, 1);
                } else {
                    allansw.push(val);
                }
            });


            if (allansw.length === 0) {
                return {
                    obj: qobj,
                    answer: qobj.Choices[check.first().val()!.toString()].Feedback,
                    response,
                    correct: true
                };
            } else if (allansw.length > 0 && check.length > 0) {
                return {
                    obj: qobj,
                    answer: qobj.Choices[allansw[allansw.length - 1]].Feedback,
                    response,
                    correct: false
                };
            }
        }
        return {
            obj: qobj,
            answer: null,
            response: null,
            correct: false
        };
    }

    private GetQById = (id: any) => {
        const min = 0;

        const filterArray = this.FlowOptions.videoParameters!.Interactions!.filter((x: any) => x.ID === id);
        const max = filterArray.length;

        if (max > 0) {
            const randomIndex = Math.round(Math.random() * ((max - 1) - min) + min);
            return filterArray[randomIndex];
        }
        return null;
    }

    private GetCurrentTime = () => {
        let time;

        switch (this.FlowOptions.videotype) {
            case 'youtube':
                if (this.FlowOptions.apiFlow) {
                    time = Math.round(this.FlowOptions.apiFlow.playerInfo.currentTime);
                }
                break;
            case 'vimeo':
                if (this.FlowOptions.api) {
                    time = Math.round(this.FlowOptions.videoposition!);
                }
                break;
            default:
                if (this.FlowOptions.apiFlow) {
                    time = this.FlowOptions.apiFlow.video.time;
                }
                break;
        }

        return time;
    }

    private Clone = (obj: any) => {
        if (null == obj || 'object' !== typeof obj) return obj;
        const copy = obj.constructor();
        for (const attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
        }
        return copy;
    }

    private ShowAnswer = () => {
        let quest = $('.quest', '#' + this.FlowOptions.question);
        const qhold = $('.q_hold', '#' + this.FlowOptions.question);
        if (quest.is(':visible')) {
            qhold.fadeOut('fast', () => {
                quest.hide();
                this.ShowAnswer();
            });
            return false;
        }

        const answ = $('.answer', '#' + this.FlowOptions.question);
        quest = $('#' + this.FlowOptions.question);
        qhold.css({
            height: 0 + 'px'
        }).show();
        answ.show();
        const qheight = answ.outerHeight()! + 40;
        const cheight = quest.height();
        qhold.hide().css({
            height: qheight + 'px',
            marginTop: (Math.max(0, (cheight !== undefined ? (cheight - qheight) / 2 : 0))) + 'px',
            // height: 'auto'
        }).fadeIn('fast');
    }

    private VideoPlay = () => {
        switch (this.FlowOptions.videotype) {
            case 'youtube': {
                this.FlowOptions.apiFlow.playVideo();
                break;
            }
            case 'vimeo': {
                this.FlowOptions.api.api('play');
                break;
            }
            default:
                {
                    this.FlowOptions.apiFlow.disable(false);
                    this.FlowOptions.apiFlow.resume();
                    break;
                }
        }
    }

    private ShowQuestion = () => {
        this.BuildEvents();
        const answ = $('.answer', '#' + this.FlowOptions.question);
        const qhold = $('.q_hold', '#' + this.FlowOptions.question);
        if (answ.is(':visible')) {
            qhold.fadeOut('fast', () => {
                answ.hide();
                this.ShowQuestion();
            });
            return false;
        }
        const qdiv = $('.quest', '#' + this.FlowOptions.question);
        if (this.FlowOptions.editmode) {
            $('.btn_skip', '#' + this.FlowOptions.question).show();
        }
        const quest = $('#' + this.FlowOptions.question);
        qdiv.show();
        $('.answer', '#' + this.FlowOptions.question).hide();
        qhold.css({
            height: 0 + 'px'
        }).show();
        quest.show();
        const qHeight = qdiv.outerHeight()! + 30;
        const cHeight = quest.height();
        qhold.hide().css({
            height: qHeight + 'px',
            marginTop: (Math.max(0, (cHeight !== undefined ? (cHeight - qHeight) / 2 : 0))) + 'px'
        }).fadeIn('fast');

    }

    private YoutubeCuePoint = () => {
        let cuepoint;

        const time = Math.round(this.FlowOptions.apiFlow.playerInfo.currentTime);

        if (this.FlowOptions.cuepoints) {
            for (const a in this.FlowOptions.cuepoints) {
                if (this.FlowOptions.cuepoints.hasOwnProperty(a)) {
                    cuepoint = this.FlowOptions.cuepoints[parseInt(a)];

                    if (cuepoint.time === time || (cuepoint.time < time && this.FlowOptions.lastcuepint! < cuepoint.num)) {
                        this.BindCuepoint(cuepoint);
                    }
                }
            }
        }
        this.VideoProgress(time);
    }

    private CheckSeekBack = () => {

        const time = this.GetCurrentTime();
        const TotalPartSec = this.FlowOptions.Tracking.TotalPartSec
        const cuepoints = this.FlowOptions.cuepoints;
        const nextCuepoint = cuepoints ? cuepoints.find((cuepoint: any) => TotalPartSec < cuepoint.time) : undefined;

        if (this.FlowOptions.editmode) {
            return false;
        }

        if (cuepoints && cuepoints.length > 0 && TotalPartSec < Math.round(this.GetCurrentTime())) {
            this.seekTo(TotalPartSec);
            return;
        }

        if (nextCuepoint) {
            this.FlowOptions.nextcuepint = nextCuepoint.num
            this.FlowOptions.lastcuepint = nextCuepoint.num - 1
        }

        const nextCuepointIndex = this.FlowOptions.nextcuepint!;

        if (cuepoints && nextCuepoint && time > nextCuepoint.time && nextCuepointIndex < cuepoints.length) {
            this.seekTo(time);
        } else {
            return false;
        }
    }

    private VideoPause = () => {
        switch (this.FlowOptions.videotype) {
            case 'youtube':
                this.FlowOptions.apiFlow.pauseVideo();
                break;
            case 'vimeo':
                this.FlowOptions.api.api('pause');
                break;
            default:
                this.FlowOptions.apiFlow.pause(() => {
                    this.FlowOptions.apiFlow.disable(true);
                });
                break;
        }
    }

    private BuildQuestion = (cuepoint: any) => {
        let ul;
        let qobj;
        let choice;
        let li;
        let i = 0;

        ul = $('ul', '#' + this.FlowOptions.question);
        qobj = this.GetQById(cuepoint.Id);

        if (!qobj) {
            return false;
        }
        $('form', '#' + this.FlowOptions.question).attr({
            rel: qobj.ID
        });

        $('.quest h4', '#' + this.FlowOptions.question).html(qobj.Question);

        // MathJax.Hub.Queue(['Typeset', MathJax.Hub])
        ul.html('');

        for (const a in qobj.Choices) {
            if (qobj.Choices.hasOwnProperty(a)) {
                choice = qobj.Choices[a];
                if (qobj.QuestionType === 'Single') {
                    li = '<li><label><input type="radio" name="q" value="' + i + '"/>' + choice.ChoiceText + '</label></li>';
                } else {
                    li = '<li><label><input type="checkbox" name="q" value="' + i + '"/>' + choice.ChoiceText + '</label></li>';
                }
                i++;
                ul.append(li);
            }
        }
        this.ShowQuestion();
    }
}
